import type { ModelVersionSearchParams } from '@/entities/model-version/domain';

export const modelVersionKeys = {
  all: ['modelVersion'] as const,

  modelVersionsPrefix: () => [...modelVersionKeys.all, 'versions'] as const,
  modelVersions: (modelName: string, params?: ModelVersionSearchParams) =>
    params
      ? ([...modelVersionKeys.modelVersionsPrefix(), modelName, params] as const)
      : ([...modelVersionKeys.modelVersionsPrefix(), modelName] as const),

  modelVersionDetailPrefix: () => [...modelVersionKeys.all, 'detail'] as const,
  modelVersionDetail: (modelName: string, version: string) =>
    [...modelVersionKeys.modelVersionDetailPrefix(), modelName, version] as const,

  modelArtifactPrefix: () => [...modelVersionKeys.all, 'artifact'] as const,
  modelArtifact: (modelName: string, version: string) =>
    [...modelVersionKeys.modelArtifactPrefix(), modelName, version] as const,

  runDetailPrefix: () => [...modelVersionKeys.all, 'run'] as const,
  runDetail: (runId: string) => [...modelVersionKeys.runDetailPrefix(), runId] as const,
} as const;
